import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useRouter from 'utils/useRouter';
import { Page, Header } from '../../../../components';
import OperatorsList from './components/OperatorsList/OperatorsList.js';
import AddOperatorDialog from './components/AddOperatorDialog/AddOperatorDialog.js';

import { GetOperators, ToggleAddOperatorDialog, DeleteOperator, NavigateDetails } from '../../actions/OperatorsActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const Operators = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { history } = useRouter();
	const user = useSelector((state) => state.session.user);
	const openAddOperatorDialog = useSelector((state) => state.operatorsReducer.openAddOperatorDialog);
	const operators = useSelector((state) => state.operatorsReducer.operators);

	const _addOperatorClose = () => {
		dispatch(ToggleAddOperatorDialog(false));
	};

	const _deleteOperator = (operator) => {
		dispatch(DeleteOperator(operator));
	};

	const _addOperator = () => {
		dispatch(ToggleAddOperatorDialog(true));
	};

	const _renderActions = () => (
		<Button color="primary" variant="contained" onClick={_addOperator}>
			<AddIcon />
			Add
		</Button>
	);

	const _navigateDetails = (operatorId) => {
		dispatch(NavigateDetails(operatorId));
		history.push('/management/operators/details');
	};

	const getData = useCallback(() => {
		dispatch(GetOperators());
	}, []);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<Page className={classes.root} title="Operators">
			<Header module="Management" view="Operators" actions={_renderActions()} />
			<Grid className={classes.content} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<OperatorsList operators={operators} deleteOperator={_deleteOperator} navigateDetails={_navigateDetails} />
				</Grid>
			</Grid>
			{openAddOperatorDialog && (
				<AddOperatorDialog
					onClose={_addOperatorClose}
					open={openAddOperatorDialog}
					user={user}
				/>
			)}
		</Page>
	);
};

export default Operators;
